<template>
  <div style="height: 100%; overflow-y: auto;">
    <div v-if="isLoaded">

      <apexchart
        v-show="isApexReady"
        :options="chartOptions"
        :series="series"
        :height="apexHeight"
      />

      <div
        v-if="items.length !== allItems.length"
      >
        <v-btn
          color="red"
          small
          class="mr-2 white--text"
          @click="showAll"
        >Показать все</v-btn>
        <span class="red--text">может долго грузиться</span>
      </div>
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

export default {
  name: 'TransferWidget',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      allItems: [],
      items: [],
      chartOptions: {
        legend: {
          show: false,
        },
        chart: {
          type: 'bar',
          background: '#00000000',
          height: 300,
          toolbar: {
            show: false
          },
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            },
          }
        },
        colors: [],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
          },
          offsetX: 0,
          dropShadow: {
            enabled: false
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: 'dark',
          custom: this.tooltip,
        },
        title: {
          show: false,
        },
        theme: {
            mode: 'light', 
        },

      },
      series: [{
        data: []
      }],
      isApexReady: false,
      apexHeight: 300,
      isLoaded: false,
    }
  },

  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },

  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme();
    },
  },

  methods: {
    ...mapActions({
      loadTransferWidget: 'dashboard/loadTransferWidget',
    }),

    tooltip({dataPointIndex}) {
      let num_transfer = this.items[dataPointIndex].num_transfer;
      let count_transfer = this.items[dataPointIndex].count_transfer;

      return `<div class="apexcharts-tooltip-rangebar">
        <span>
          Переведено на: ${num_transfer} <br>
          Количество переводов: ${count_transfer}
        </span>
      </div>`;
    },

    fillApexData(isAll = false) {
      this.allItems.sort((a, b) => {
        if (a.count_transfer <= b.count_transfer) return 1
        return -1
      })

      if (!isAll)
        this.items = this.allItems.slice(0, 50); // Обрезаем items'ы чтоб не было проблем с рендером
      else this.items = this.allItems;
      
      this.chartOptions.xaxis.categories = 
        this.items.flatMap(item => item.num_transfer);

      this.series[0].data = 
        this.items.flatMap(item => item.count_transfer);

      this.chartOptions.xaxis.max = Math.max(...this.series[0].data) + 10;

      let apexHeight = this.items.length * 25;
      if (apexHeight > 300) this.apexHeight = apexHeight;

      this.series[0].data.forEach(r => {
        let clr = '';
        if (r < 10) clr = '#8BC34A';
        if (r >= 10 && r < 100) clr = '#009688';
        if (r >= 100) clr = '#00BCD4';
        this.chartOptions.colors.push(clr);
      })


      this.isApexReady = true;
    },

    changeApexTheme() {
      this.isLoaded = false;

      if (this.isDarkTheme) {
        this.chartOptions.chart.background = '#00000000'
        this.chartOptions.theme.mode = 'dark'
        this.chartOptions.dataLabels.style.colors = ['#fff']
      } else {
        this.chartOptions.chart.background = '#00000000'
        this.chartOptions.theme.mode = 'light'
        this.chartOptions.dataLabels.style.colors = ['#222']
      }

      setTimeout(() => {
        this.isLoaded = true;
      }, 700);
    },

    showAll() {
      this.isLoaded = false;
      this.isApexReady = false;
      this.fillApexData(true);
      setTimeout(() => {
        this.isLoaded = true;
      }, 700);
    },

    async loadData() {
      this.isLoaded = false;
      this.allItems = await this.loadTransferWidget(this.widget.params);
      this.fillApexData();
      this.isLoaded = true;
    },
  },
  
  async mounted() {
    await this.loadData();
    this.changeApexTheme();
  },
}
</script>


<style scoped lang="scss">
.colorfull_cell {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;

  &.green {
    background-color: #4CAF5040 !important;
  }
  &.red {
    background-color: #F4433640 !important;
  }
}
.name-cell {
  display: grid;
  align-items: center;
  padding-left:0.2rem;
  padding-right:0.2rem;

  &.name {
    min-width: 120px;
    width: 100%;
  }

  .sliced-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>